export const genreOptions: string[] = ["剧情", "爱情", "悬疑", "犯罪"];

export const regionOptions: string[] = ["国产", "欧美", "日韩"];

export const yearOptions: string[] = ["全部", "2024", "2023", "2022", "2021"];

export const sortOptions: { key: string; label: string }[] = [
  { key: "default", label: "默认推荐" },
  { key: "year", label: "按上映时间" },
  { key: "score", label: "按评分高低" },
];

export const quickCategories: { name: string; icon: string; desc: string }[] = [
  { name: "剧情", icon: "ri-book-open-line", desc: "细腻讲述人性与命运" },
  { name: "爱情", icon: "ri-heart-3-line", desc: "关于心动与错过" },
  { name: "悬疑", icon: "ri-spy-line", desc: "层层反转,烧脑推理" },
  { name: "犯罪", icon: "ri-shield-flash-line", desc: "追凶与正义的较量" },
];

export const featuredCategoryTags: string[] = [
  "国产剧情",
  "爱情悬疑",
  "欧美犯罪",
  "日韩爱情",
  "高分推荐",
  "全新上线",
];